import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import SEO from '../../components/SEO';

// Import the new modular components
import ContactHero from './ContactHero';
import ContactInfo from './ContactInfo';
import ContactForm from './ContactForm';
import ContactFAQ from './ContactFAQ';

const Contact = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [t]);

  // Structured data for contact page
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Rossopomodoro Reykjavik',
      alternateName: 'Best Italian Restaurant Reykjavik',
      description:
        'Contact Rossopomodoro Reykjavik, the best Italian restaurant in downtown Reykjavik. Authentic Neapolitan pizza, fresh pasta, and Italian cuisine since 2006.',
      image: 'https://rossopomodoro.is/images/hero11.jpg',
      url: 'https://rossopomodoro.is',
      telephone: '+354 561 0500',
      email: 'larusg@simnet.is',
      priceRange: '$$',
      paymentAccepted: ['Cash', 'Credit Card', 'Debit Card'],
      currenciesAccepted: 'ISK',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Laugavegi 40a',
        addressLocality: 'Reykjavík',
        postalCode: '101',
        addressCountry: 'IS',
        addressRegion: 'Capital Region',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 64.14469761638455,
        longitude: -21.928471483883666,
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.5',
        reviewCount: '150',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '12:00',
          closes: '22:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Sunday',
          opens: '17:00',
          closes: '22:00',
        },
      ],
      servesCuisine: ['Italian', 'Neapolitan', 'Pizza', 'Pasta'],
      foundingDate: '2006',
      keywords:
        'contact Italian restaurant, restaurant phone number, Laugavegur restaurant, downtown Reykjavik dining',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://rossopomodoro.is/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Contact',
          item: 'https://rossopomodoro.is/contact',
        },
      ],
    },
  ];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEO
        title={`${t.contact.hero.title} | Rossopomodoro`}
        description="Contact Rossopomodoro Reykjavik, best Italian restaurant downtown. Call +354 561 0500, visit Laugavegur 40a, or book online. Authentic Neapolitan pizza & pasta."
        canonical="https://rossopomodoro.is/contact"
        keywords="contact Italian restaurant Reykjavik, Rossopomodoro phone number, Laugavegur 40a, restaurant reservations, Italian restaurant contact, downtown Reykjavik dining"
        ldjson={structuredData}
      />

      {/* Compose the modular components */}
      <ContactHero />

      {/* Contact Info and Form */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <ContactInfo />
            <ContactForm />
          </div>
        </div>
      </section>

      <ContactFAQ />
    </motion.div>
  );
};

export default Contact;
